// Fire-and-forget client error reporter.
// Posts to /api/log/error. Silent on its own failure (never throws).
import { API } from '../api';

const queue = [];
let flushing = false;

async function flush() {
  if (flushing || queue.length === 0) return;
  flushing = true;
  const batch = queue.splice(0, queue.length);
  try {
    await Promise.all(
      batch.map((doc) =>
        fetch(`${API}/log/error`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(doc),
          keepalive: true,
        }).catch(() => null)
      )
    );
  } finally {
    flushing = false;
  }
}

export function reportError(context, error, extras) {
  try {
    const message = error?.message || String(error || 'unknown');
    const stack = error?.stack;
    const doc = {
      context: String(context).slice(0, 120),
      message: message.slice(0, 1200),
      stack: stack ? String(stack).slice(0, 3000) : null,
      url: typeof window !== 'undefined' ? window.location.href : null,
      user_agent: typeof navigator !== 'undefined' ? navigator.userAgent : null,
      extras: extras || null,
    };
    // Mirror to console so devs see it locally
    // eslint-disable-next-line no-console
    console.warn(`[${doc.context}]`, message, extras || '');
    queue.push(doc);
    flush();
  } catch (e) {
    // Never let the reporter itself throw
    // eslint-disable-next-line no-console
    console.warn('[reportError] dropped:', e);
  }
}

// Global hook for uncaught errors / promise rejections
if (typeof window !== 'undefined' && !window.__pocErrorHooked) {
  window.__pocErrorHooked = true;
  window.addEventListener('error', (ev) => {
    reportError('window.onerror', ev?.error || ev?.message, {
      filename: ev?.filename,
      lineno: ev?.lineno,
      colno: ev?.colno,
    });
  });
  window.addEventListener('unhandledrejection', (ev) => {
    reportError('unhandledrejection', ev?.reason);
  });
}
